import { supabase } from "@/integrations/supabase/client";
import { isMemberReadStateEnabled } from "@/lib/member-read-state-flags";

type MarkReadResult = { error: Error | null };

export async function markConversationRead(conversationId: string): Promise<MarkReadResult> {
  if (isMemberReadStateEnabled()) {
    const { error } = await supabase.rpc("mark_conversation_read" as never, {
      p_conversation_id: conversationId,
    } as never);
    return { error: error ? new Error(error.message) : null };
  }

  const { error } = await supabase
    .from("conversations")
    .update({ unread_count: 0 } as never)
    .eq("id", conversationId);

  return { error: error ? new Error(error.message) : null };
}

export async function markConversationUnread(
  conversationId: string,
  options?: { minUnread?: number },
): Promise<MarkReadResult> {
  if (isMemberReadStateEnabled()) {
    const { error } = await supabase.rpc("mark_conversation_unread" as never, {
      p_conversation_id: conversationId,
    } as never);
    return { error: error ? new Error(error.message) : null };
  }

  const minUnread = options?.minUnread ?? 1;
  const { error } = await supabase
    .from("conversations")
    .update({ unread_count: minUnread } as never)
    .eq("id", conversationId);

  return { error: error ? new Error(error.message) : null };
}
